module.exports = __webpack_public_path__ + "img/washi.afd0fd72.png";